import { createGlobalStyle } from 'styled-components'
import { theme } from '../theme'

const GlobalStyles = createGlobalStyle`

body {
  -webkit-font-smoothing: antialiased;
    ::-webkit-scrollbar {
    background-color: ${theme.colors.colorf3f5f9};
    width: 16px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.colorf3f5f9};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.colorbabac0};
    border-radius: 16px;
    border: 4px solid ${theme.colors.colorf3f5f9};
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
}

* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  strong {
    font-weight: 700;
  }

  h3 {
    font-size: 1.17em;
    font-weight: 700;
  }

`

export { GlobalStyles }
